export default __webpack_public_path__ + "static/media/sort-up.55604d20.svg";